import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import { useAuthStore } from '../../../../store';
import useGetAgentByIdQuery from '../../../../http/queries/resources/useGetAgentById';
import { useParams } from 'react-router-dom';

const SimcardFullView = ({ ...props }) => {
    const { id: agentId } = useParams();
    const userProfile = useAuthStore((state) => state.userProfile);
    const { isLoading, data: agent } = useGetAgentByIdQuery(agentId);
    return (
        <Container fluid>
            <></>
        </Container>
    );
};
export default SimcardFullView;
